<template>
  <v-menu
    v-model="menuOpen"
    :close-on-content-click="false"
    transition="scale-transition"
    min-width="290px"
  >
    <template v-slot:activator="{ props }">
      <v-text-field
        v-bind="props"
        :model-value="modelValue"
        :label="label"
        placeholder="MM/DD/YYYY"
        prepend-icon="mdi-calendar"
        readonly
      />
    </template>
    <v-date-picker
      :model-value="modelValue"
      hide-header
      color="primary"
      @update:modelValue="onUpdate"
      :min="min"
      :max="max"
      :show-current="false"
    />
  </v-menu>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { formatDate } from '@/services/data-export'

export default defineComponent({
  name: 'DatePickerMenu',
  props: {
    modelValue: { type: String, default: null },
    label: { type: String, required: true },
    min: { type: String, default: undefined },
    max: { type: String, default: undefined }
  },
  emits: ['update:modelValue'],
  data() {
    return {
      menuOpen: false
    }
  },
  methods: {
    onUpdate(value: string) {
      this.$emit('update:modelValue', formatDate(value))
      this.menuOpen = false
    }
  }
})
</script>
